export const VetChatCheckoutForm = {
  AcceptedTerms: 'acceptedTerms',
  AddOrChangePaymentBtn: 'add-or-change-payment-btn',
  ErrorText: 'error-text',
  NoPaymentMethodText: 'no-payment-method-text',
  SubmitBtn: 'submit-btn',
} as const;
